module.exports = __webpack_public_path__ + "r-v3/img/ml_11_00.9992e026.jpg";